"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signOutRequestFlow = void 0;
var tslib_1 = require("tslib");
var createErrorAction_1 = require("./../../actionCreators/createErrorAction");
var getIsExistingTokenFromState_1 = require("./../../state/getters/getIsExistingTokenFromState");
var effects_1 = require("redux-saga/effects");
var selectState_1 = require("../../state/selectState");
var takeGaurd_1 = require("../../utilities/takeGaurd");
var normalizeNotificationTokens_1 = require("../../functions/utilities/normalizeNotificationTokens");
var auth_1 = require("firebase/auth");
var setUnscopeUserClient_1 = require("../../functions/utilities/ref/set/setUnscopeUserClient");
var firestore_1 = require("firebase/firestore");
// Should not take too much time and should ignore all errors
var description = 'signOutRequestFlow';
var signOutRequestFlow = function () {
    var _loop_1;
    var _a;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _loop_1 = function () {
                    var state, notificationTokens, currentUserId, isExistingToken, firebaseMessagingToken_1, newMessagingTokens, _c;
                    return tslib_1.__generator(this, function (_d) {
                        switch (_d.label) {
                            case 0: return [4 /*yield*/, (0, takeGaurd_1.takeGaurd)('SIGN_OUT_REQUEST_ACTION')];
                            case 1:
                                _d.sent();
                                return [4 /*yield*/, (0, effects_1.select)(selectState_1.selectState)];
                            case 2:
                                state = _d.sent();
                                notificationTokens = (0, normalizeNotificationTokens_1.normalizeNotificationTokens)({
                                    unscopeUser: state.currentUnscopeUser || undefined,
                                });
                                currentUserId = state.currentUserId || undefined;
                                if (!currentUserId) return [3 /*break*/, 7];
                                isExistingToken = (0, getIsExistingTokenFromState_1.getIsExistingTokenFromState)({ state: state });
                                firebaseMessagingToken_1 = (_a = state.windowMeta) === null || _a === void 0 ? void 0 : _a.firebaseMessagingToken;
                                if (!(isExistingToken && notificationTokens)) return [3 /*break*/, 6];
                                newMessagingTokens = notificationTokens.filter(function (notificationToken) {
                                    return firebaseMessagingToken_1 !== notificationToken.token;
                                });
                                _d.label = 3;
                            case 3:
                                _d.trys.push([3, 5, , 6]);
                                return [4 /*yield*/, (0, setUnscopeUserClient_1.setUnscopeUserClient)({
                                        firestore: (0, firestore_1.getFirestore)(),
                                        userId: currentUserId,
                                        unscopeUser: {
                                            notificationTokens: newMessagingTokens,
                                        },
                                        merge: true,
                                    })];
                            case 4:
                                _d.sent();
                                return [3 /*break*/, 6];
                            case 5:
                                _c = _d.sent();
                                return [3 /*break*/, 6];
                            case 6:
                                (0, auth_1.signOut)((0, auth_1.getAuth)());
                                if (window.setBadgeCount) {
                                    window.setBadgeCount({ badgeCount: 0 });
                                }
                                return [3 /*break*/, 9];
                            case 7: return [4 /*yield*/, (0, effects_1.put)((0, createErrorAction_1.createErrorAction)({
                                    description: description,
                                }))];
                            case 8:
                                _d.sent();
                                _d.label = 9;
                            case 9: return [2 /*return*/];
                        }
                    });
                };
                _b.label = 1;
            case 1:
                if (!1) return [3 /*break*/, 3];
                return [5 /*yield**/, _loop_1()];
            case 2:
                _b.sent();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
};
exports.signOutRequestFlow = signOutRequestFlow;
